<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <div>
              <router-link to="/atencion">Atenciones</router-link> >
              <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link> 
              > Atención Obstétrica
            </div>
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;" @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>
    <hr>
<!-- Modal -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAtenObst" class="form-label">IdAtenObst</label>
                </div>
                <div class="col-10">
                 <input type="text" class="form-control" id="idAtenObst" name="idAtenObst" v-model="datoAtenObst.idAtenObst" disabled>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="lugControl" class="form-label">Lugar de Control</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control"
                            id="lugControl"
                            name="lugControl"
                            :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                            v-model="datoAtenObst.lugControl" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="lugParto" class="form-label">Lugar de Parto</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control" 
                            id="lugParto"
                            name="lugParto"
                            :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                            v-model="datoAtenObst.lugParto" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="peso" class="form-label">Peso</label>
                </div>
                <div class="col-2">
                  <input type="number"
                         class="form-control"
                         id="peso"
                         name="peso"
                         :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                         v-model="datoAtenObst.peso"
                         @input="validatePeso" required>
                </div>
                <div class="col-1">
                  <label for="talla" class="form-label">Talla</label>
                </div>
                <div class="col-2">
                  <input type="number"
                         class="form-control"
                         id="talla"
                         name="talla"
                         :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                         v-model="datoAtenObst.talla"                         
                         @input="validateTalla" required>
                </div>
                <div class="col-1">
                  <label for="fum" class="form-label">FUM</label>
                </div>
                <div class="col-2">
                  <input type="date"
                         class="form-control"
                         id="fum"
                         name="fum"
                         :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                         v-model="formattedFum" required>
                </div>
                <div class="col-1">
                  <label for="fpp" class="form-label">FPP</label>
                </div>
                <div class="col-2">
                  <input type="date" class="form-control" id="fpp" name="fpp" v-model="formattedFpp" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="viveSola" class="form-label">Vive Sola</label>
                </div>
                <div class="col-1">
                  <select class="form-control"
                          id="viveSola"
                          name="viveSola"
                          :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                          v-model="datoAtenObst.viveSola" required>
                    <option :value="1">Sí</option>
                    <option :value="0">No</option>
                  </select>
                </div>
                <div class="col-1">
                </div>
                <div class="col-3">
                  <label for="consejeriaAC" class="form-label">Consejería Anticoncepción</label>
                </div>
                <div class="col-1">
                  <select class="form-control"
                          id="consejeriaAC"
                          name="consejeriaAC"
                          :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                          v-model="datoAtenObst.consejeriaAC" required>
                    <option :value="1">Sí</option>
                    <option :value="0">No</option>
                  </select>
                </div>                
                <div class="col-2">
                  <label for="idAnticonceptivo" class="form-label">Anticonceptivo</label>
                </div>
                <div class="col-2 ">
                  <select class="form-control"
                          id="idAnticonceptivo"
                          name="idAnticonceptivo"
                          :disabled="p_estadoAtencion!= 'PENDIENTE' && p_estadoAtencion!= 'PROCESO'"
                          v-model="datoAtenObst.idAnticonceptivo">
                    <option v-for="anticonceptivo in anticonceptivos" :value="anticonceptivo.idAnticonceptivo" :key="anticonceptivo.idAnticonceptivo">
                      {{ anticonceptivo.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button v-if="p_estadoAtencion === 'PENDIENTE' || p_estadoAtencion === 'PROCESO'"
                type="submit"
                class="btn btn-light"
                @click.prevent="guardarEditAtenObst"
                title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button class="tablink" @click="showTable = 'anteAten'" :class="{ 'active-tab': showTable === 'anteAten' }">
        Antecedentes
      </button>
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->
    <div v-if="showTable === 'anteAten'">
      <AnteAten :p_idAtencion="p_idAtencion" :p_estadoAtencion="p_estadoAtencion" :p_tipoAntecedente="'O'"></AnteAten>
    </div>
  
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AnteAten from '../forms/AnteAten.vue';
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer, AnteAten
  },
  data () {
    return {
      atenobsts : [],
      datoAtenObst : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idAtencion: 0,
      p_numero: 0,
      p_estadoAtencion: '',
      atencions: [],
      anticonceptivos: [],
//      formattedFum: '',
      showTable: 'anteAten01',
      datosListos: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
   watch: {
    formattedFum(newFum) {
      if (newFum) {
        this.calculateFpp(newFum);
      } else {
        this.formattedFpp = ''; // Resetear FPP si la FUM está vacía
      }
    }
  },
  computed: {
    formattedFum: {
      get() {
        if (!this.datoAtenObst.fum) return '';
        const date = new Date(this.datoAtenObst.fum);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoAtenObst.fum = date.toISOString();
      }
    },
    formattedFpp: {
      get() {
        if (!this.datoAtenObst.fpp) return '';
        const date = new Date(this.datoAtenObst.fpp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoAtenObst.fpp = date.toISOString();
      }
    },
  },
  mounted () {
    this.p_idAtencion = this.$route.params.p_idatencion
    this.getData()
    this.p_numero = this.$route.params.p_numero
    this.p_estadoAtencion = this.$route.params.p_estadoatencion
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchAnticonceptivos();
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    validatePeso() {
      if (this.datoAtenObst.peso < 0) {
        this.datoAtenObst.peso = 0;
        alert("El peso no puede ser menor que 0");
      }
    },
    validateTalla() {
      if (this.datoAtenObst.talla < 0) {
        this.datoAtenObst.talla = 0;
        alert("La talla no puede ser menor que 0");
      }
    },
    async getData() {
      api.get('/vwatenobsts/idatencion/' + this.p_idAtencion)
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.datoAtenObst = response.data[0];
          } else {
            this.datoAtenObst = {}; // Reinicia el objeto si no hay datos
          }
          this.datosListos = true;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
          this.datosListos = true; // Para que, incluso en caso de error, intente mostrar el componente
        });
        await api.get('/vwbiomatens/idatencion-idbiometria/' + this.p_idAtencion + '/5')
            .then(resp => {
              if (resp.data && resp.data.length > 0) {
                const item = resp.data[0];
                this.datoAtenObst.peso = item.valor || '';
              }
            });
            await api.get('/vwbiomatens/idatencion-idbiometria/' + this.p_idAtencion + '/6')
            .then(resp => {
              if (resp.data && resp.data.length > 0) {
                const item = resp.data[0];
                this.datoAtenObst.talla = item.valor || '';
              }
            }); 
    },
    validarForm(){
      const requiredFields = [
        'idAtencion'
        ,'viveSola'
        ,'lugControl'
        ,'lugParto'
        ,'peso'
        ,'talla'
        ,'fpp'
        ,'fum'
        ,'consejeriaAC'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'viveSola'
        ,'lugControl'
        ,'lugParto'
        ,'peso'
        ,'talla'
        ,'fpp'
        ,'fum'
        ,'consejeriaAC'
      ];
      return validarForm(this.datoAtenObst, requiredFields, requiredFieldsText);
    },
    async guardarEditAtenObst(){
      this.datoAtenObst.idAtencion = this.p_idAtencion;
      if(this.validarForm() === 1){
        try {
          await api.post('/atenobsts', this.datoAtenObst)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AtenObst creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async fetchAnticonceptivos() {
      try {
        const { data } = await api.get('/vwanticonceptivos');
        this.anticonceptivos = data;
      } catch (error) {
        console.error('Error fetching anticonceptivos:', error);
      }
    },
    calculateFpp(fum) {
      if (fum) {
        let fumDate = new Date(fum);
        // Sumar 280 días a la FUM
        let fppDate = new Date(fumDate);
        fppDate.setDate(fppDate.getDate() + 280);

        // Formatear la fecha a 'YYYY-MM-DD' para mostrar en el campo de fecha
        this.formattedFpp = fppDate.toISOString().split('T')[0];
      }      
    },
  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
